var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "0" } },
    [
      _c(
        "v-menu",
        {
          staticClass: "my-location-floating-menu",
          staticStyle: { "box-shadow": "none" },
          attrs: {
            transition: "slide-y-transition",
            attach: "body",
            "close-on-click": true,
            top: "",
            "offset-y": "",
            "close-on-content-click": true
          },
          model: {
            value: _vm.menuOpen,
            callback: function($$v) {
              _vm.menuOpen = $$v
            },
            expression: "menuOpen"
          }
        },
        [
          _vm.locationActive
            ? _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "smart-tooltip",
                      rawName: "v-smart-tooltip",
                      value: {
                        show: _vm.toolTipVisible,
                        text: _vm.$t("myLocation.myPositionToolTip"),
                        position: "left",
                        dark: true,
                        showOnce: true,
                        name: "useMyLocation",
                        forceShow: _vm.showTooltip
                      },
                      expression:
                        "{show: toolTipVisible, text: $t('myLocation.myPositionToolTip'), position: 'left', dark: true, showOnce: true, name: 'useMyLocation', forceShow: showTooltip}"
                    }
                  ],
                  staticClass: "my-location-btn",
                  attrs: {
                    slot: "activator",
                    small: "",
                    fab: "",
                    title: _vm.$t("myLocation.stopShowingCurrentLocation")
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.activatorClicked()
                    }
                  },
                  slot: "activator"
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        large: "",
                        color: _vm.continuously === true ? "primary" : "dark"
                      }
                    },
                    [_vm._v("my_location")]
                  )
                ],
                1
              )
            : _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "smart-tooltip",
                      rawName: "v-smart-tooltip",
                      value: {
                        show: _vm.toolTipVisible,
                        text: _vm.$t("myLocation.myPositionToolTip"),
                        dark: true,
                        showOnce: true,
                        name: "useMyLocation",
                        forceShow: _vm.showTooltip
                      },
                      expression:
                        "{show: toolTipVisible, text: $t('myLocation.myPositionToolTip'), dark: true, showOnce: true, name: 'useMyLocation', forceShow: showTooltip}"
                    }
                  ],
                  staticClass: "my-location-btn",
                  attrs: {
                    slot: "activator",
                    small: "",
                    fab: "",
                    title: _vm.$t("myLocation.showCurrentLocation")
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.activatorClicked()
                    }
                  },
                  slot: "activator"
                },
                [
                  _c("v-icon", { attrs: { large: "", color: "dark" } }, [
                    _vm._v("person_pin_circle")
                  ])
                ],
                1
              ),
          _vm._v(" "),
          !_vm.locationActive
            ? _c(
                "v-list",
                {
                  staticClass: "input-pop-up-list",
                  staticStyle: {
                    background: "transparent",
                    "box-shadow": "none"
                  },
                  attrs: { light: "" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-xs-right" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "text-transform": "initial" },
                          attrs: {
                            round: "",
                            title: _vm.$t("myLocation.continuouslyLocation")
                          },
                          on: {
                            click: function($event) {
                              return _vm.setLocationFromBrowser(true)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("myLocation.continuously")) +
                              "\n          "
                          ),
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("autorenew")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-xs-right" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "text-transform": "initial" },
                          attrs: {
                            round: "",
                            title: _vm.$t("myLocation.onlyOnceLocation")
                          },
                          on: {
                            click: function($event) {
                              return _vm.setLocationFromBrowser()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("myLocation.onlyOnce")) +
                              "\n          "
                          ),
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("play_for_work")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a46281f", { render: render, staticRenderFns: staticRenderFns })
  }
}